module.exports = __webpack_public_path__ + "static/img/6.2b2f895b.jpg";